import React from "react";
import "./SettingsTabNav.css";

/**
 * The tab bar every settings pane shares.
 *
 * Kept as one component so the settings area cannot drift into several
 * dialects of the same control: any change to the pattern lands everywhere.
 *
 * tabs: [{ id, label, icon?, count?, badge? }]
 *   icon  — Font Awesome class, e.g. 'fa-envelope'
 *   count — hidden when falsy
 *   badge — short marker like 'AI', for panes that carry their own identity
 */
const SettingsTabNav = ({ tabs, activeId, onChange, ariaLabel = "Sections" }) => (
  <div className="stn" role="tablist" aria-label={ariaLabel}>
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        role="tab"
        aria-selected={activeId === tab.id}
        className={`stn-tab ${activeId === tab.id ? "active" : ""}`}
        onClick={() => onChange(tab.id)}
      >
        {tab.icon && (
          <span className="stn-tabIcon">
            <i className={`fa ${tab.icon}`} />
          </span>
        )}
        <span className="stn-tabLabel">{tab.label}</span>
        {tab.badge && <span className="stn-tabBadge">{tab.badge}</span>}
        {tab.count > 0 && <span className="stn-tabCount">{tab.count}</span>}
      </button>
    ))}
  </div>
);

export default SettingsTabNav;
